var anime = require("animejs").default;

var ComponentsStage = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.$dropdown = this.options.$el.find(".component-selector-wrapper select");

};

ComponentsStage.prototype.init = function(){

  var self = this;

  this.$dropdown.on("change", function(){

    var $el = $(this);
    var component = $el.val();
    var $componentContainer = self.options.$el.find(".component-container[data-component-name='"+component+"']");

    console.log(".component-container[data-component-name='"+component+"']");
    console.log($componentContainer);

    anime({
      targets: 'html, body',
      scrollTop: $componentContainer.offset().top,
      duration: 600,
      easing: "easeInOutQuart"
    });

  });

};

export default  ComponentsStage;
